var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "inquiry end"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h2", null, "基本情報登録完了", -1);
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_12 = { class: "bt_group bt_home" };
import { Link } from '@inertiajs/inertia-vue3';
import { inject, onMounted, ref } from 'vue';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import swal from 'sweetalert';
import { loadStripe } from '@stripe/stripe-js';
export default /*#__PURE__*/ _defineComponent({
    __name: 'profile_complete',
    props: {
        common: null,
        user_type: null,
        payment_intent_client_secret: null
    },
    setup(__props) {
        const props = __props;
        const PAID_USER = 'paid_user';
        const FREE_USER = 'free_user';
        const auth_3ds_complete = ref('');
        let stripe = null;
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            const publishableKey = inject('stripePublicKey');
            const secretKey = inject('stripeSecretKey');
            const stripePromise = loadStripe(publishableKey);
            const stripe = yield stripePromise;
            if (props.payment_intent_client_secret) {
                // this means 3ds auth case
                const payment_intent_client_secret = props.payment_intent_client_secret;
                const result = yield stripe.retrievePaymentIntent(payment_intent_client_secret);
                if (result.error) {
                    auth_3ds_complete.value = "failed";
                }
                else {
                    if (result.paymentIntent.status === 'requires_payment_method') {
                        // Authentication failed
                        swal({
                            title: "確認",
                            text: "クレジットカードの認証に失敗したので、フリー会員として登録しました。料金プラン変更画面でプランの変更を行ってください。",
                            icon: "warning",
                            buttons: {
                                ok: {
                                    text: "OK",
                                    className: "timeout-ok-btn",
                                },
                            },
                        });
                        auth_3ds_complete.value = "failed";
                    }
                    else {
                        auth_3ds_complete.value = "success";
                    }
                }
            }
            else {
                auth_3ds_complete.value = "success";
            }
        }));
        return (_ctx, _cache) => {
            return (auth_3ds_complete.value !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(headerVue, {
                        common: props.common
                    }, null, 8, ["common"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("p", null, [
                                        (props.user_type === PAID_USER && auth_3ds_complete.value === 'success')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "会員"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_8, "無料会員として")),
                                        _createTextVNode(" 登録が完了しました。ありがとうございます。"),
                                        _hoisted_9,
                                        _createTextVNode(" 貴社のビジネス課題解決に向けて、尽力してまいります。"),
                                        _hoisted_10,
                                        _createTextVNode(" 今後とも何卒宜しくお願い申し上げます。"),
                                        _hoisted_11
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_unref(Link), {
                                        href: _ctx.route('question.index'),
                                        class: "bt_home"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("ホームに戻る")
                                        ]),
                                        _: 1
                                    }, 8, ["href"]),
                                    (props.user_type === FREE_USER || auth_3ds_complete.value === 'failed')
                                        ? (_openBlock(), _createBlock(_unref(Link), {
                                            key: 0,
                                            href: _ctx.route('plan.show'),
                                            class: "bt_home"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("料金プラン変更")
                                            ]),
                                            _: 1
                                        }, 8, ["href"]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        _createVNode(footerVue)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
